// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from '@hotwired/stimulus'

const application = Application.start()

// All controllers go into ONE async chunk (lazy-once), not 30 separate ones.
// One network request, deferred from the critical path, cached on repeat visits.
const context = require.context('controllers', true, /_controller\.js$/, 'lazy-once')

function loadAllControllers() {
  Promise.all(
    context.keys().map(key =>
      context(key).then(mod => ({
        identifier: key
          .replace(/^\.\//, '')
          .replace(/_controller\.js$/, '')
          .replace(/\//g, '--')
          .replace(/_/g, '-'),
        controllerConstructor: mod.default
      }))
    )
  ).then(definitions => application.load(definitions))
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadAllControllers, { once: true })
} else {
  loadAllControllers()
}

// https://github.com/hotwired/stimulus/issues/328
// used to reset the xcare form and get rid of spinning button
window.addEventListener('pageshow', (event) => {
  application.controllers.forEach((controller) => {
    if (typeof controller.pageShow === 'function') {
      controller.pageShow(event.persisted)
    }
  })
})
